import { useState } from "react";
import Header from "../../components/Header";
import Footer from "../../components/Footer";

export default function Tutor() {
   

    return (
        <>
            <Header />
            <div class="ai-ifm-div">
                <div class="ai-ifm-div-sub">
                <iframe src="https://tutor.nugenesisou.com/"  height="800" class="relative w-full overflow-hidden" allow="fullscreen; clipboard-write; autoplay" ></iframe>
                </div>
            </div>
            <Footer />
        </>
    );
}
